import { useEffect } from "react"

import { IListItem } from "components/List/List"
import useArticleClasses from "hooks/useArticleClasses"
import { ArticleClassField } from "models/ArticleClassInfo"
import { ArticleEquipment } from "models/ArticleEquipment"
import Asset from "models/Asset"
import { ArticleAny } from "@/types"
import { GlobalAssetOverviewAsset } from "models/GlobalAssetOverviewAsset"
import { AssetTechnicalDataField } from "hooks/useAssetTechnicalDataFields"

interface IUseAssetSummaryTechnicalDataParams {
    asset: Asset | GlobalAssetOverviewAsset | null
    article: ArticleAny | null
    getFields: (fields: AssetTechnicalDataField[]) => IListItem[]
}

export default function useAssetSummaryTechnicalData({
    asset,
    article,
    getFields,
}: IUseAssetSummaryTechnicalDataParams): IListItem[] {

    const {
        fetchArtcleClasses,
        articleClassHasField,
    } = useArticleClasses()

    useEffect(() => {
        if (article instanceof ArticleEquipment) {
            fetchArtcleClasses()
        }
    }, [article, fetchArtcleClasses])

    let technicalDataItems: IListItem[] = getFields([
        AssetTechnicalDataField.color,
    ])

    if (!(article instanceof ArticleEquipment)) {
        technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.emissionLevel])]
    }

    if (article instanceof ArticleEquipment ? articleClassHasField(article.articleClass, ArticleClassField.dimensions) : true) {
        technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.dimensions])]
    }

    if (article instanceof ArticleEquipment ? articleClassHasField(article.articleClass, ArticleClassField.volume) : true) {
        technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.volume])]
    }

    if (article instanceof ArticleEquipment ? articleClassHasField(article.articleClass, ArticleClassField.weight) : true) {
        technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.weight])]
    }

    if (asset && article instanceof ArticleEquipment) {
        if (articleClassHasField(article.articleClass, ArticleClassField.quickCouplingSystem)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.quickCouplingSystem])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.connectionType)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.connectionType])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.cuttingEdge)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.boltOnCuttingEdge])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.teeth)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.teeth])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.heavyDuty)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.heavyDuty])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.locking)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.locking])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.controlSystem)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.controlSystem])]
        }

        if (articleClassHasField(article.articleClass, ArticleClassField.agility)) {
            technicalDataItems = [...technicalDataItems, ...getFields([AssetTechnicalDataField.agility])]
        }
    }

    return technicalDataItems
}
